import { PromptBoxProps } from './PromptBox.types'
import { Sparkle } from '@audio-network/componentlibrary/icons'
import { Text } from '@audio-network/componentlibrary'
import styles from './PromptBox.module.css'
import { useTranslation } from 'next-i18next'

const PromptBox = ({
	prompt,
	showExplanation,
}: PromptBoxProps): JSX.Element => {
	const { t } = useTranslation(['search'])
	return (
		<div className={styles.promptBox}>
			<div className={styles.promptBoxTryAi}>
				<div className={styles.promptBoxTryAiIcon}>
					<Sparkle
						color="electricBlue"
						className={styles.promptBoxTryAiIconSparkle}
					/>
				</div>
				<Text bold className={styles.promptBoxTryAiText}>
					{t('try-prompt-search')}:
				</Text>
				<Text className={styles.promptBoxPrompt}>{prompt}</Text>
			</div>
			{showExplanation && (
				<div className={styles.promptBoxExplanation}>
					<Text bold display="block">
						{t('what-is-prompt-search')}
					</Text>
					<Text>{t('what-is-prompt-search-description')}</Text>
				</div>
			)}
		</div>
	)
}

export default PromptBox
